import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
// Redux
import { useDispatch } from 'react-redux';
// External Component
import moment from 'moment';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import { Button, Collapse } from 'react-bootstrap';
import cx from 'classnames';

// Component
import Avatar from '../../Avatar';
import ContactHost from '../ContactHost';
import Link from '../../Link';

// Redux Action
import { contactHostOpen } from '../../../actions/message/contactHostModal';

// Locale
import messages from '../../../locale/messages';
import { CommonAngleDownIcon, CommonAngleUpIcon } from '../../Common/Assets/SvgComponent/commonSvgIcon';
import s from './HostDetail.css';
import bt from '../../../components/commonStyle.css';

const HostDetail = (props) => {

  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const handleClick = () => { setOpen(!open) };

  const { isHost, hostEmail, userBanStatus, urlParameters } = props;
  const { id, personCapacity, userId, city, blockedDates, country } = props;
  const { profile: { profileId, firstName, picture, info, createdAt } } = props;
  const { listingData: { minNight, maxNight, maxDaysNotice } } = props;
  let count = 150, firstArray, restArray, dotString = false, joinedDate, initialValues;

  joinedDate = createdAt != null ? moment(parseInt(createdAt)).format("MMMM YYYY") : '';
  initialValues = {
    listId: id,
    host: userId,
    hostEmail,
    firstName,
    startDate: urlParameters.startDate,
    endDate: urlParameters.endDate,
    personCapacity: urlParameters.guests,
  };
  if (info) {
    firstArray = info.slice(0, count);
    restArray = info.slice(count, info.length);
  }
  if (restArray && restArray.length > 0) {
    dotString = true;
  }

  return (
    <div>
      <ContactHost
        initialValues={initialValues}
        id={id}
        userId={userId}
        city={city}
        profileId={profileId}
        picture={picture}
        displayName={firstName}
        personCapacity={personCapacity}
        blockedDates={blockedDates}
        minNight={minNight}
        maxNight={maxNight}
        maxDaysNotice={maxDaysNotice}
        country={country}
      />
      <div className={cx(s.pageContent)}>
        <div className={s.flex}>
          <div>
            <Avatar
              source={picture}
              height={63}
              width={63}
              title={firstName}
              className={s.profileAvatar}
              withLink
              linkClassName={s.profileAvatarLink}
              profileId={profileId}
            />
          </div>
          <div>
            <Link to={"/users/show/" + profileId}>
              <h1 className={s.titleText}>
                <FormattedMessage {...messages.hostedBy} /> {' '}  {firstName}
              </h1>
            </Link>
            <p className={cx(s.textMuted)}><FormattedMessage {...messages.joinedIn} /> {joinedDate}</p>
          </div>
        </div>
        <div className={cx(s.infoContent)}>
          {!open && count >= 150 && dotString === true &&
            <span className={cx(s.subText, s.lineBreak)}>  {firstArray} ...</span>
          }
          {!open && count >= 150 && dotString === false &&
            <span className={cx(s.subText, s.lineBreak)}>  {firstArray}</span>
          }
          {
            restArray && restArray.length > 0 &&
            <span>
              <Collapse in={open}>
                <div> <span className={cx(s.subText, s.lineBreak)}>
                  {firstArray}{restArray}
                </span></div>
              </Collapse>
              {
                dotString && <div className={s.btnContainer}>
                  <div className={s.showHidePadding}>
                    <Button
                      bsStyle="link"
                      className={cx(s.button, s.noPadding, s.btnLInk, s.showHideBtn, 'bgTransparent')}
                      onClick={() => handleClick()}
                    >
                      {
                        !open ? <FormattedMessage {...messages.showMore} /> : <FormattedMessage {...messages.showLess} />
                      }
                      {
                        open ? <CommonAngleUpIcon className1={s.navigationIcon} /> : <CommonAngleDownIcon className2={s.navigationIcon} />
                      }
                    </Button>
                  </div>
                </div>
              }
            </span>
          }

        </div>
        {/* {
          !isHost && !userBanStatus && <Button className={cx(s.btn, bt.btnLarge, bt.btnPrimary)} onClick={() => dispatch(contactHostOpen(id, urlParameters))}>
            <FormattedMessage {...messages.contactHost} />
          </Button>
        } */}
      </div>
      <div className={s.listingLine}></div>
    </div>
  );
}

HostDetail.propTypes = {
  id: PropTypes.number.isRequired,
  userId: PropTypes.string.isRequired,
  personCapacity: PropTypes.number.isRequired,
  city: PropTypes.string.isRequired,
  profile: PropTypes.shape({
    profileId: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    picture: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
    info: PropTypes.string,
  }).isRequired,
  listingData: PropTypes.shape({
    minNight: PropTypes.number,
    maxNight: PropTypes.number,
    maxDaysNotice: PropTypes.string,
  }).isRequired,
  blockedDates: PropTypes.array,
  isHost: PropTypes.bool.isRequired,
  userBanStatus: PropTypes.number,
  country: PropTypes.string,
  urlParameters: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    guests: PropTypes.string,
    listTitle: PropTypes.string
  })
};
HostDetail.defaultProps = {
  id: 0,
  userId: null,
  userBanStatus: 0,
  personCapacity: 0,
  city: null,
  profile: {
    profileId: 0,
    displayName: null,
    picture: null,
    createdAt: null,
    info: null
  },
  listingData: {
    minNight: 0,
    maxNight: 0
  },
  blockedDates: [],
  showContactHostModal: false,
  isHost: false,
  country: null,
  urlParameters: null
}

export default withStyles(s, bt)(HostDetail);
